import FlowEdge from "./edges/FlowEdge";
import { useFlowStore } from "../../../../../stores/WorkflowStore";
import "reactflow/dist/style.css";
import ReactFlow, { Background, Controls, ReactFlowProvider } from "reactflow";
import StartNode from "./nodes/StartNode";
import { useEffect, useLayoutEffect } from "react";
import TrailEdge from "./edges/TrailEdge";
import { handleLayout } from "./layouter";
import { Button, Flex } from "@mantine/core";
import BaseNode from "./nodes/BaseNode";
import "./flowStyles.scss";
import WorkflowSaver from "./panel/WorkflowSaver";
import { useParams } from "react-router-dom";
import WorkflowListingModal from "../../listing/WorkflowListingModal";
import { useUIStore } from "../../../../../stores/UIStore";
import FirstStepCreation from "./onboarding/FirstStepCreation";
import { IconSwitchVertical } from "@tabler/icons-react";
import { getDefaultZoom } from "./flowUtils";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useSessionStore } from "../../../../../stores/UserStore";
import { updateProfile, updateSelf } from "../../../../../api/UserAPI";

const edgeTypes = {
  main: FlowEdge,
  trail: TrailEdge,
};

const nodeTypes = {
  start: StartNode,
  action: BaseNode,
};

const FlowHorizontal = ({
  setShouldWarn,
  setFlowInstance,
  setIsAi,
  isAi,
  setActive,
}) => {
  const lang = useLanguage((s) => s.language);
  const loadingPage = useFlowStore((s) => s.loadingPage);
  const nodes = useFlowStore((s) => s.nodes);
  const edges = useFlowStore((s) => s.edges);
  const headerClosed = useUIStore((s) => s.headerClosed);
  const { workflowId, campaignId } = useParams();

  const handleNodesChange = (change) => {
    setShouldWarn?.(true);
  };

  const handleNodeClick = (e, node) => {
    setShouldWarn?.(true);
    return false;
  };

  useLayoutEffect(() => {
    handleLayout();
  }, [workflowId]);

  const handleSwitch = () => {
    let switched = !!useSessionStore.getState().user_switch;

    if (!switched) {
      updateProfile(null, { show_new_workflow_builder: false }).then(() =>
        updateSelf(),
      );
    }

    useFlowStore.getState().setLayout("vertical");
  };

  return (
    <Flex
      h={"100%"}
      mih={headerClosed ? "calc(100vh - 68px)" : "calc(100vh - 124px)"}
      style={{ overflow: "hidden" }}
      pt={12}
    >
      <ReactFlowProvider>
        <ReactFlow
          id="workflow"
          nodes={nodes.filter((x) => x.type !== "trail")}
          nodeTypes={nodeTypes}
          edges={edges}
          onNodesChange={handleNodesChange}
          onInit={setFlowInstance}
          connectOnClick={false}
          panOnScroll
          panOnScrollMode="vertical"
          panOnDrag={true}
          zoomOnScroll={false}
          preventScrolling
          // fitView
          defaultEdgeOptions={{
            type: "main",
            deletable: false,
            focusable: false,
            updatable: false,
          }}
          defaultViewport={{
            x: 0,
            y: 0,
            zoom: getDefaultZoom(),
          }}
          edgeTypes={edgeTypes}
          disableKeyboardA11y
          nodesDraggable={false}
          proOptions={{
            hideAttribution: true,
          }}
          zoomOnDoubleClick={false}
          edgesUpdatable={false}
          edgesFocusable={false}
          onNodeClick={handleNodeClick}
        >
          <Background />
          <Controls position="top-right" showInteractive={false} />

          {((nodes.length === 1 && nodes[0].type === "start") ||
            nodes.length === 0) &&
            !loadingPage && (
              <FirstStepCreation
                isAi={isAi}
                setIsAi={setIsAi}
                setActive={setActive}
              />
            )}
          <Button
            pos={"absolute"}
            top={16}
            right={64}
            style={{ zIndex: 600 }}
            rightSection={<IconSwitchVertical size={16} />}
            variant="outline"
            bg={"#fff"}
            size="sm"
            onClick={handleSwitch}
            radius={"lg"}
          >
            {lang.campaign.popup_new.btn_change_to_old}
          </Button>
        </ReactFlow>

        {/* <NodeActionPanel /> */}
      </ReactFlowProvider>

      <WorkflowSaver />

      {!campaignId && <WorkflowListingModal />}
    </Flex>
  );
};

export default FlowHorizontal;
